import dataPeriEdo from "../../../../src/data/periprocedureel-beleid-edoxaban.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriEdo,
  BasicSchematic,
  React
};